import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/main.scss'
import App from './App'
// import { onCLS } from 'web-vitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

// Report Web Vitals
// onCLS(console.log)
